export const CustomerGroupsResource = {
  name: "Customer Groups",
  path: "/sales/customer-groups",
  access: ["read-customergroups"],
};
